export { default } from './exactProp';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/exactProp/index.js
// module id = 442
// module chunks = 25